import classNames from 'classnames'

import s from './Text.module.scss'

type TextProps = {
  children: string
  error?: boolean
  className?: string
}

export const ErrorText = ({ children, error, className }: TextProps) => {
  const cls = classNames(s.Text, className, {
    [s.error]: error,
  })

  return (
    <div className={cls}>
      <p>{children}</p>
    </div>
  )
}
